import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { map, catchError, switchMap, concatMap, mergeMap } from 'rxjs/operators';
import { PerformanceService } from '../../../services/http/performance.service';
import { IPerformance, AssetPerformanceRequest } from './../../../models/performance';
import { PerformanceActions } from '../action-types';
import {
  assetPerformanceDataError,
  assetPerformanceDataLoaded,
  performanceDataError,
  performanceDataLoaded
} from '../actions/performance.actions';
import { deduplicatingSwitchMap } from 'src/app/utils/deduplicatingSwitchMap';

@Injectable()
export class PerformanceEffects {

  loadPerformanceData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PerformanceActions.loadPerformanceData),
      deduplicatingSwitchMap((action) =>
        this.performanceService
          .getPerformanceData(<IPerformance>action.payload)
          .pipe(
            map((data) => performanceDataLoaded({ payload: data })),
            catchError((error) => {
              const errorMessage =
                `Unfortunately Performance data couldn't be loaded. ${error.error.message}`;
              return of(performanceDataError({ errorMessage }));
            })
          )
      )
    )
  );

  loadAssetPerformanceData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PerformanceActions.loadAssetPerformanceData),
      deduplicatingSwitchMap((action) =>
        this.performanceService
          .getAssetPerformanceData(<AssetPerformanceRequest>action.payload)
          .pipe(
            map((data) => assetPerformanceDataLoaded({ payload: data })),
            catchError((error) => {
              const errorMessage =
                `Unfortunately Performance data couldn't be loaded. ${error.error.message}`;
              return of(assetPerformanceDataError({ errorMessage }));
            })
          )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private performanceService: PerformanceService
  ) {}
}
